import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import './HealthspanWelcomeModal.scss';

SwiperCore.use([Pagination]);

const DEFAULT_SLIDES = [
  {
    showBackground: false,
    content: (
      <div className="welcome-slide-00">
        <img src="/images/nutrition-and-rehabilitation/welcome00.png" alt="" />
      </div>
    ),
  },
  {
    showBackground: true,
    content: (
      <div className="welcome-slide">
        <img src="/images/nutrition-and-rehabilitation/welcome01.png" alt="" />
      </div>
    ),
  },
  {
    showBackground: true,
    content: (
      <div className="welcome-slide">
        <img src="/images/nutrition-and-rehabilitation/welcome02.png" alt="" />
      </div>
    ),
  },
  {
    showBackground: true,
    content: (
      <div className="welcome-slide">
        <img src="/images/nutrition-and-rehabilitation/welcome03.png" alt="" />
      </div>
    ),
  },
  {
    showBackground: true,
    content: (
      <div className="welcome-slide">
        <img src="/images/nutrition-and-rehabilitation/welcome04.png" alt="" />
      </div>
    ),
  },
];

const HealthspanWelcomeModal = ({
  isOpen,
  onClose,
  slides = DEFAULT_SLIDES,
  onComplete,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  const isLastSlide = activeIndex === slides.length - 1;
  const showBackground = slides[activeIndex]?.showBackground ?? false;

  // Reset to first slide when modal opens
  useEffect(() => {
    if (isOpen && swiperRef.current) {
      swiperRef.current.slideTo(0, 0);
      setActiveIndex(0);
    }
  }, [isOpen]);

  const handleNext = () => {
    if (isLastSlide) {
      if (onComplete) {
        onComplete();
      }
      if (onClose) {
        onClose();
      }
    } else if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="healthspan-welcome-modal">
      {showBackground && (
        <img
          className="healthspan-welcome-modal__background"
          src="/images/nutrition-and-rehabilitation/landing-bg-detail.svg"
          alt=""
        />
      )}

      <div className="healthspan-welcome-modal__content">
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          onSlideChange={handleSlideChange}
          slidesPerView={1}
          spaceBetween={0}
          pagination={{
            clickable: true,
            el: '.healthspan-welcome-modal__pagination',
          }}
          className="healthspan-welcome-modal__swiper"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index} className="healthspan-welcome-modal__slide">
              <div className="healthspan-welcome-modal__slide-content">
                {slide.content}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="healthspan-welcome-modal__footer">
        <div className="healthspan-welcome-modal__pagination" />
        <button
          className="healthspan-welcome-modal__next-btn"
          onClick={handleNext}
        >
          <img src="/images/nutrition-and-rehabilitation/next-button.svg" alt="next" />
        </button>
      </div>
    </div>
  );
};

export default HealthspanWelcomeModal;
